import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../../auth/service/auth.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetCustomerService {

  apiUrl: string = environment.apiUrl;
   testApi = 'https://test.api.tridimo.de/api/';
   devApi = 'https://dev.api.tridimo.de/api/';
   storedData: any

  constructor(private http: HttpClient, private authService: AuthService) { }

  async getStoredData() {
    this.storedData = localStorage.getItem("authUser"); 
  }

  checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime > expirationTime) {
        console.log('Token ist älter als 60 Minuten');
        this.logout()
      } else {
        console.log('Token ist noch gültig');
      }
    } catch (e) {
      console.error('Fehler beim Dekodieren des Tokens:', e);
      this.logout()
    }
  }


  logout() {
    //localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
  }


setFetchOptions(): { headers?: HttpHeaders; withCredentials?: boolean } {
  let options: { headers?: HttpHeaders; withCredentials?: boolean } = {};

  if (this.apiUrl === this.devApi) {
    let token = '';
    this.getStoredData();
    if (this.storedData) {
      try {
        const parsedData = JSON.parse(this.storedData);
        token = parsedData.token;
        this.checkToken(parsedData.exp);
      } catch {
        this.logout();
      }
    } else {
      this.logout();
    }

    options.headers = new HttpHeaders({
      Authorization: `${token}`,
      'Content-Type': 'application/json'
    });
  } else {
    options.withCredentials = true;
  }

  return options;
}

async fetchCustomerSearch(name: string): Promise<any[]> {
  const options = this.setFetchOptions();
  const queryString = `firstname=${name}&lastname=${name}`;

  const response = await lastValueFrom(
    this.http.get<any[]>(
      `${this.apiUrl}search/customer?${queryString}`,
      { ...options, observe: 'body' as const }  // Body erzwingen
    )
  );

  return response ?? [];
}

  async fetchCustomerWithId(id: any) {
    const options = this.setFetchOptions();
    const response = await this.http.get(
      `${this.apiUrl}customer/${id}`,
      options
    ).toPromise();
    // console.log(response)
    return response
  }

  async fetchCustomer() {
    const options = this.setFetchOptions();
    const response = await this.http.get(
      `${this.apiUrl}customer`,
      options
    ).toPromise();
    // console.log(response)
    return response
  }
}